<div class="tooltip-container" [style.--tooltip-width]="width">
    <div class="icon"> <img src="svg/info.svg"> </div>
    <span class="text">{{ text }}</span>
</div>